import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import { CURRENCIES } from "components/i18n/source";
import { useAppContext } from "components/store/source";
import { Button, Dropdown, Modal, Text } from "components/ui/source";

import { IconCheckmark, IconRightChevron } from "icons";

import styles from "./Selector.module.scss";

function CurrencyButton({ code, label, sign, selected }) {
  const { updateCurrency } = useAppContext();
  return (
    <Button
      className={classNames(styles.itemButton, selected && styles.selected)}
      type="navbar_signup"
      onClick={() => updateCurrency(code)}
      fullWidth
      centered={false}
    >
      {selected && (
        <IconCheckmark className={styles.checkmark} size="md" color="black" />
      )}
      <Text types={["body1", "medium"]}>{code}</Text>
      <Text className={styles.currencyLabel} types={["body1"]}>
        {label}
      </Text>
      <Text className={styles.currencySign} types={["body1"]}>
        ({sign})
      </Text>
    </Button>
  );
}

CurrencyButton.propTypes = {
  code: PropTypes.string,
  label: PropTypes.string,
  sign: PropTypes.string,
  selected: PropTypes.bool,
  onChange: PropTypes.func,
};

function CurrencyList() {
  const { currency } = useAppContext();
  return (
    <div className={classNames(styles.listWrapper, styles.currencyListWrapper)}>
      <Text
        className={styles.title}
        types={["body1", "inline"]}
        translateKey="navbar.currencySelector.title"
      />
      <ul className={styles.list}>
        {CURRENCIES.map(info => (
          <li className={styles.item} key={info.code}>
            <CurrencyButton selected={currency === info.code} {...info} />
          </li>
        ))}
      </ul>
    </div>
  );
}

function CurrencySelector({ className, isMobile }) {
  const {
    currencySelectorPopupIsOpen,
    closeCurrencySelectorPopup,
    openCurrencySelectorPopup,
    currency,
  } = useAppContext();

  const currencyInfo = CURRENCIES.find(info => info.code === currency);

  const modalProps = {
    isOpen: currencySelectorPopupIsOpen,
    onRequestClose: closeCurrencySelectorPopup,
    className: styles.modalContent,
  };

  const selector = (
    <>
      <Text types={["body1"]}>{currencyInfo.code}</Text>
      <Text className={styles.currencySign} types={["body1"]}>
        ({currencyInfo.sign})
      </Text>
    </>
  );

  if (isMobile) {
    return (
      <>
        <Modal modalProps={modalProps}>
          <Modal.Close
            className={styles.modalCloseButton}
            onClick={closeCurrencySelectorPopup}
          />
          <CurrencyList />
        </Modal>

        <Button
          className={className}
          type="navbar_signup"
          onClick={openCurrencySelectorPopup}
          upperCase={false}
        >
          {selector}
          <IconRightChevron
            className={styles.rightChevron}
            size="sm"
            color="black"
          />
        </Button>
      </>
    );
  }

  return (
    <Dropdown
      className={classNames(styles.selectorDropdown, className)}
      alignRight
      width="fit-content"
      buttonType="navbar_signup"
      label={selector}
      outlineOnFocus={false}
      noIcon
    >
      <CurrencyList />
    </Dropdown>
  );
}

CurrencySelector.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default CurrencySelector;
